import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Alert, Panel, Button } from 'react-bootstrap';
import { FormActions, ConfirmationButton, Input } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const IndividualConsultationForm = ({ title, formComponent, initialValues, error, handleSubmit, onSubmit, submitting, isReadonly, allowNotes, allowSaveNotes,
	pristine, submitSucceeded, allowUndoSubmit, undoSubmit, allowDraft = true, allowFinal = true, saveDraftButtonText, actionsAlignRight = true, t }) => {
	const saveDraft = handleSubmit(values => onSubmit(values, false));	// isFinal: false
	const saveFinal = handleSubmit(values => onSubmit(values, true));	// isFinal: true
	return (<div>
		<h3>{title}</h3>
		<Form horizontal>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			{formComponent}
			{allowNotes && <Panel>
				<Panel.Heading>{t('IndividualConsultationForm_Notes')}</Panel.Heading>
				<Panel.Body>
					<Field name='notes' component={Input} horizontal componentClass='textarea' rows={6} labelCol={0} valueCol={12} />
				</Panel.Body>
			</Panel>}
			<FormActions horizontal>
				<div className={actionsAlignRight && 'pull-right'} style={{ marginBottom: '5px', marginLeft: '5px' }}>
					{allowUndoSubmit && <ConfirmationButton bsStyle='primary' displayType={'inline'}
						onConfirmation={undoSubmit} icon={faEdit}
						disabled={submitting}
						type='submit'
						confirmationTitle={t('IndividualConsultationForm_UndoSubmit_Confirm')}
						confirmationMessage={t('IndividualConsultationForm_UndoSubmit_ConfirmMessage')}
						label={t('IndividualConsultationForm_UndoSubmit')} />}
					{allowDraft && !isReadonly && <Button onClick={saveDraft} disabled={submitting} bsStyle='primary' displayType={'inline'} style={{ marginRight: '5px' }} >
						{saveDraftButtonText || <React.Fragment><FontAwesomeIcon icon={faEdit} /> {t('IndividualConsultationForm_SaveDraft')}</React.Fragment>}
					</Button>}
					{allowFinal && !isReadonly && <ConfirmationButton bsStyle='primary' displayType={'inline'}
						onConfirmation={saveFinal} icon={faCheck}
						disabled={isReadonly || submitting}
						type='submit'
						confirmationTitle={t('IndividualConsultationForm_Save_Confirm')}
						confirmationMessage={t('IndividualConsultationForm_Save_ConfirmMessage')}
						label={t('IndividualConsultationForm_SaveFinal')} />}
					{allowSaveNotes && <Button bsStyle='primary' style={{ marginLeft: '5px' }} onClick={saveFinal}>{t('IndividualConsultationForm_Save_Notes')}</Button>}
				</div>
			</FormActions>
		</Form>
	</div>
	);
};

export default reduxForm({ form: 'customForm', enableReinitialize: true })(withTranslation()(IndividualConsultationForm));